import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { periodSelector, taxYearSelector } from '../../../shared/store/selectors';
import SelectContextDataInfo from '../../../shared/displayComponents/selectContextDataInfo/selectContextDataInfo.component';
import Loading from '../../../shared/displayComponents/loading.component';
import GenericSourceData from '../genericSourceData/genericSourceData.container';
import ManualAccountsGrid from '../../../shared/displayComponents/customizedScreen/manualAccounts/manualAccountsGrid.container';

import useCustomizedScreen from './useCustomizedScreen.hook';
import { screenTypes } from './constants';

const CustomizedScreenForComponentDrill = ({
  match,

  taxYear,
  period,
  orgId,
  jurisdictionId,
  isFetchingContext,

  categoryId,
  accountId,
}) => {
  const { params } = match;
  const { componentId } = params;
  const isContextReady =
    taxYear && period && orgId && jurisdictionId && categoryId && accountId && componentId;

  const { customizedScreen, isFetchingCustomizedScreen } = useCustomizedScreen({
    taxYear,
    period,
    orgId,
    jurisdictionId,
    categoryId,
    accountId,
    componentId,
  });

  const isLoading = isFetchingContext || isFetchingCustomizedScreen;

  if (isLoading) {
    return (
      <div className="grid-row">
        <div className="col">
          <Loading isLoading />
        </div>
      </div>
    );
  }

  if (!isContextReady || !customizedScreen.type) {
    return <SelectContextDataInfo />;
  }

  if (customizedScreen.type === screenTypes.SOURCE_SYSTEM_DATA) {
    return (
      <GenericSourceData
        orgId={orgId}
        jurisdictionId={jurisdictionId}
        isFetchingContext={isFetchingContext}
        categoryId={categoryId}
        accountId={accountId}
        componentId={componentId}
      />
    );
  }
  return <ManualAccountsGrid manualAccounts={customizedScreen.manualAccounts} />;
};

CustomizedScreenForComponentDrill.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      componentId: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,

  categoryId: PropTypes.string,
  accountId: PropTypes.string,

  taxYear: PropTypes.string,
  period: PropTypes.string,
  orgId: PropTypes.string,
  jurisdictionId: PropTypes.string,
  isFetchingContext: PropTypes.bool.isRequired,
};

export default connect(
  state => ({
    taxYear: taxYearSelector(state),
    period: periodSelector(state),
  }),
  null,
)(CustomizedScreenForComponentDrill);
